export default __webpack_public_path__ + "static/media/7.39b39f0d.png";